webpackJsonp([109],{

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dabad1f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("YEof")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1DHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_cell = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("VTU+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_cell,
  src_components_cell,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2sLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_button = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("dh/b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_button,
  src_components_x_button,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2sm9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "32ER":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a1f8152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-box/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box weui-cell",class:_vm.className,style:(_vm.style),on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_cell_box = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-box/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("hBGW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_cell_box,
  src_components_cell_box,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_box = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3k2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("KhEi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6OHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export joinErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_app_model__ = __webpack_require__("rTN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configs_axios__ = __webpack_require__("cjHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);





/**
 * Created by denishuang on 2017/8/2.
 */



// import store from '../store'
function joinErrors(errors) {
    var es = {};
    for (var n in errors) {
        es[n] = errors[n].join('');
    }
    return es;
}

/* harmony default export */ __webpack_exports__["a"] = (function (appModel, defaults, eventor) {
    var m = {
        appModel: appModel,
        defaults: defaults || {},
        eventor: eventor,
        config: {},
        id: null,
        fieldConfigs: {},
        options: {},
        errors: {},
        data: {},
        viewsConfig: undefined,

        init: function init() {
            this.config = __WEBPACK_IMPORTED_MODULE_5__utils_app_model__["a" /* Register */].getConfig(this.appModel);
            this.loadOptions();
        },
        clear: function clear() {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.data, this.emptyDataFromOptions(this.fieldConfigs));
            this.id = null;
            this.errors = {};
        },
        loadData: function loadData() {
            var _this = this;

            if (!this.id) {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve({});
            } else {
                return __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].get(this.getDetailUrl()).then(function (_ref) {
                    var data = _ref.data;

                    _this.id = data.id;
                    return data;
                });
            }
        },
        loadOptions: function loadOptions() {
            var _this2 = this;

            if (this.config.rest_options) {
                this.cacheOptions(this.config.rest_options);
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(this.config.rest_options);
            }
            return __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].options(this.getListUrl()).then(function (_ref2) {
                var data = _ref2.data;

                _this2.config.rest_options = data;
                _this2.cacheOptions(_this2.config.rest_options);
                return data;
            });
        },
        cacheOptions: function cacheOptions(options) {
            var _this3 = this;

            this.options = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.options, options);
            this.fieldConfigs = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.fieldConfigs, options.actions.LIST, options.actions.POST);
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.fieldConfigs).forEach(function (a) {
                _this3.fieldConfigs[a].name = a;
            });
        },
        emptyDataFromOptions: function emptyDataFromOptions(m) {
            var dvs = {};
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(dvs, this.defaults);
            var r = {};
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(m).forEach(function (k) {
                var f = m[k];
                var v = dvs[f.name] || f.default;
                if (v !== undefined) {
                    r[k] = v;
                } else if (f.type === 'boolean') {
                    r[k] = true;
                } else if (f.multiple) {
                    r[k] = [];
                } else if (f.type === 'string') {
                    r[k] = '';
                } else if (f.type === 'nested object') {
                    r[k] = {};
                } else {
                    r[k] = null;
                }
                // r[k] = v !== undefined ? v : (f.type === 'boolean' ? true : f.multiple ? [] : f.type === 'string' ? '' : null)
            });
            return r;
        },
        fillEmptyDataFromOptions: function fillEmptyDataFromOptions(r) {
            var m = this.fieldConfigs;
            var dvs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.defaults);
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(m).forEach(function (k) {
                if (!(k in r)) {
                    var f = m[k];
                    var v = dvs[f.name] || f.default;
                    r[k] = v !== undefined ? v : f.type === 'boolean' ? true : f.multiple ? [] : f.type === 'string' ? '' : null;
                }
            });
        },
        load: function load() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.loadData(), this.loadOptions(), this.loadViewsConfig()]).then(function (rs) {
                var data = rs[0],
                    restOptions = rs[1];
                if (!_this4.id) {
                    data = _this4.emptyDataFromOptions(restOptions.actions.POST);
                }
                _this4.data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this4.data, data);
                return rs;
            });
        },
        save: function save(data) {
            var _this5 = this;

            var d = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.defaults, this.data, data);
            var promise = void 0;
            if (!this.id) {
                promise = __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].post(this.getListUrl(), d);
            } else {
                promise = __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].patch(this.getDetailUrl(), d);
            }
            return promise.then(function (_ref3) {
                var data = _ref3.data;

                _this5.id = data.id;
                _this5.data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this5.data, data);
                _this5.emitPosted(_this5.id);
                return data;
            }); // .catch((error) => this.onErrors(error))
        },
        doAction: function doAction(action, data, method, id) {
            if (!method) {
                method = 'post';
            }
            if (!id) {
                id = this.id;
            }
            method = __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */][method];
            if (action.length > 0 && !action.endsWith('/')) {
                action = action + '/';
            }
            if (!id) {
                return method('' + this.getListUrl() + action, data);
            } else {
                return method('' + this.getDetailUrl(id) + action, data);
            }
        },
        selectOrCreate: function selectOrCreate(d) {
            var url = this.getListUrl();
            return __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].get(url + '?' + __WEBPACK_IMPORTED_MODULE_7_qs___default.a.stringify(d)).then(function (_ref4) {
                var data = _ref4.data;

                if (data.count === 1) {
                    return data.results[0];
                } else if (data.count === 0) {
                    return __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].post(url, d).then(function (_ref5) {
                        var data = _ref5.data;

                        return data;
                    });
                } else {
                    throw Error('记录不唯一');
                }
            });
        },
        removeRelateObject: function removeRelateObject(rel, id) {
            this.data[rel] = this.data[rel].filter(function (a) {
                return a !== id;
            });
            return this.save();
        },
        destroy: function destroy(id) {
            var _this6 = this;

            id = id || this.id;
            return __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].delete(this.getDetailUrl(id)).then(function () {
                _this6.eventor && _this6.eventor.$emit('model-deleted', { appModel: _this6.appModel, id: id });
            });
        },
        emitPosted: function emitPosted(id) {
            this.eventor && this.eventor.$emit('model-posted', { appModel: this.appModel, id: id });
        },
        onErrors: function onErrors(error) {
            if (error.code === 400) {
                this.errors = joinErrors(error.msg);
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
        },
        checkPermission: function checkPermission(p, ps) {
            if (!ps) {
                return false;
            }
            var pn = this.appModel.replace('.', '.' + p + '_');
            return ps.includes(pn);
        },
        getListUrl: function getListUrl() {
            return '/' + this.appModel.replace('.', '/') + '/';
        },
        getDetailUrl: function getDetailUrl(id) {
            var mid = id || this.id;
            return '' + this.getListUrl() + mid + '/';
        },
        query: function query(d, url) {
            if (!url) {
                url = this.getListUrl();
            }
            return __WEBPACK_IMPORTED_MODULE_6__configs_axios__["a" /* default */].get(url + '?' + __WEBPACK_IMPORTED_MODULE_7_qs___default.a.stringify(d, { arrayFormat: 'comma' })).then(function (_ref6) {
                var data = _ref6.data;

                return data;
            });
        },
        title: function title() {
            return !this.id && '\u65B0\u589E' + this.config.verbose_name || this.data['__str__'];
        },
        loadViewsConfig: function loadViewsConfig() {
            var _this7 = this;

            if (this.viewsConfig) {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(this.viewsConfig);
            }
            return __webpack_require__("lZ1g")("./views" + this.getListUrl() + 'config.js').then(function (m) {
                return m.default || {};
            }).catch(function (err) {
                console.warn('\u627E\u4E0D\u5230\u89C6\u56FE\u914D\u7F6E@/views' + _this7.getListUrl() + 'config.js,\u5C06\u4F7F\u7528\u9ED8\u8BA4\u914D\u7F6E, err: ' + err);
                return {};
            }).then(function (config) {
                _this7.viewsConfig = config;
                return config;
            });
        },
        loadOptionsAndViewsConfig: function loadOptionsAndViewsConfig() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.loadOptions(), this.loadViewsConfig()]);
        },
        parentMultipleRelationField: function parentMultipleRelationField(parent) {
            var _this8 = this;

            if (parent) {
                var pfs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(parent.fieldConfigs);
                var f = pfs.find(function (a) {
                    return a.model === _this8.appModel;
                });
                if (f && f.multiple === true) {
                    return f;
                }
            }
            return null;
        },
        getParentQueries: function getParentQueries(parent, pct_id) {
            var r = {};
            if (parent) {
                var f = this.parentMultipleRelationField(parent);
                if (f) {
                    var ids = parent.data[f.name];
                    r['id__in'] = ids.length > 0 && ids || [0];
                } else {
                    var am = parent.appModel;
                    var pid = parent.id;
                    var fs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.fieldConfigs);
                    var _f = fs.find(function (a) {
                        return a.model === am;
                    });
                    if (_f && _f.multiple !== true) {
                        r[_f.name] = pid;
                    } else {
                        var popt = this.options;
                        if (popt.generic_foreign_key) {
                            var _popt$generic_foreign = popt.generic_foreign_key,
                                ct_field = _popt$generic_foreign.ct_field,
                                fk_field = _popt$generic_foreign.fk_field;

                            r[ct_field] = pct_id;
                            if (!this.fieldConfigs[fk_field]) {
                                throw Error('genric foreign key id_field:' + fk_field + ' not found.');
                            }
                            r[fk_field] = pid || undefined;
                        }
                    }
                }
            }
            return r;
        },
        getOptionDisplayName: function getOptionDisplayName(f, v) {
            return this.fieldConfigs[f].choices.find(function (a) {
                return a.value === v;
            }).display_name;
        }
    };
    m.init();
    return m;
});

/***/ }),

/***/ "7XXH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A66B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function (file) {
  return function () {
    return __webpack_require__("Opzk")("./" + file + '.vue');
  };
};

/***/ }),

/***/ "A6zj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/**
 * Created by denishuang on 2019/8/25.
 */

/* harmony default export */ __webpack_exports__["a"] = (function (items, templates, normalize) {
    // console.log(templates)
    // if(!(templates instanceof Array)) {
    //     templates = [templates]
    // }
    if (items === 'all' && templates) {
        items = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(templates);
    }
    return items.map(function (a, i) {
        var d = {};
        if (typeof a === 'string' || a instanceof String) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(d, templates[a]);
            d.name = a;
        } else if (a instanceof Array) {
            d = a;
        } else {
            // templates.forEach(t => {
            //     Object.assign(d, t[a.name])
            // })
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(d, templates[a.name], a);
            // console.log(d)
        }
        if (normalize) {
            d = normalize(d, i);
        }
        return d;
    });
});

/***/ }),

/***/ "B9AI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("TDCR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D8a4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc96ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_badge = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("2sm9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_badge,
  src_components_badge,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EtwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/index.vue + 3 modules
var cell = __webpack_require__("1DHf");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell-box/index.vue + 3 modules
var cell_box = __webpack_require__("32ER");

// EXTERNAL MODULE: ./node_modules/vux/src/components/badge/index.vue + 3 modules
var badge = __webpack_require__("D8a4");

// EXTERNAL MODULE: ./vue-django/src/mixins/server_response.js
var server_response = __webpack_require__("mVB0");

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./vue-django/src/utils/filters.js
var filters = __webpack_require__("hwoK");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/message/components/List.vue










/* harmony default export */ var List = ({
  mixins: [server_response["a" /* default */]],
  props: {
    queries: { type: Object, default: {} },
    autoLoad: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      messages: []
    };
  },

  components: { Group: group["a" /* default */], Cell: cell["a" /* default */], CellBox: cell_box["a" /* default */], Badge: badge["a" /* default */] },
  created: function created() {
    this.autoLoad && this.load();
  },

  methods: {
    load: function load() {
      var _this = this;

      return this.$http.get('/message/message/current/?' + lib_default.a.stringify(this.queries)).then(function (_ref) {
        var data = _ref.data;

        _this.messages = data.results.map(function (m) {
          var title = m.is_active ? m.title : '此消息已被删除';
          var senderName = m.sender_name || '系统';
          var sendTime = Object(filters["d" /* formatTime */])(m.create_time);
          var d = { key: m.id, title: title, task: m.task_object, isRead: m.is_read, senderName: senderName, sendTime: sendTime };
          if (m.is_read) {
            d.inlineDesc = senderName + '  ' + sendTime;
          }
          if (m.is_active && m.task_object) {
            var t = m.task_object;
            var arrowDirection = t.content ? 'down' : null;
            var isLink = Boolean(t.link || arrowDirection);
            assign_default()(d, { isLink: isLink, arrowDirection: arrowDirection, content: t.content });
          }
          return d;
        });

        _this.$emit('loaded', data);
      }).catch(this.onServerResponseError);
    },
    onTitleClick: function onTitleClick(m) {
      var _this2 = this;

      if (m.arrowDirection === 'down') {
        m.arrowDirection = 'up';
      } else if (m.arrowDirection === 'up') {
        m.arrowDirection = 'down';
      }
      if (!m.isRead) {
        this.read(m).then(function () {
          if (!m.task.content) {
            _this2.goLink(m);
          }
        });
      } else {
        if (!m.task.content) {
          this.goLink(m);
        }
      }
    },
    onContentClick: function onContentClick(m) {
      this.goLink(m);
    },
    goLink: function goLink(m) {
      var link = m.task.link;
      if (link) {
        this.$emit('golink', link);
        this.$router.push(link);
      }
    },
    read: function read(m) {
      return this.$http.post('/message/message/' + m.key + '/read/').then(function (_ref2) {
        var data = _ref2.data;

        m.isRead = true;
        m.inlineDesc = m.senderName + '  ' + m.sendTime;
      });
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/message/components/List.vue










/* harmony default export */ var components_List = ({
  mixins: [server_response["a" /* default */]],
  props: {
    queries: { type: Object, default: {} },
    autoLoad: { type: Boolean, default: true }
  },
  data: function data() {
    return {
      messages: []
    };
  },

  components: { Group: group["a" /* default */], Cell: cell["a" /* default */], CellBox: cell_box["a" /* default */], Badge: badge["a" /* default */] },
  created: function created() {
    this.autoLoad && this.load();
  },

  methods: {
    load: function load() {
      var _this = this;

      return this.$http.get('/message/message/current/?' + lib_default.a.stringify(this.queries)).then(function (_ref) {
        var data = _ref.data;

        _this.messages = data.results.map(function (m) {
          var title = m.is_active ? m.title : '此消息已被删除';
          var senderName = m.sender_name || '系统';
          var sendTime = Object(filters["d" /* formatTime */])(m.create_time);
          var d = { key: m.id, title: title, task: m.task_object, isRead: m.is_read, senderName: senderName, sendTime: sendTime };
          if (m.is_read) {
            d.inlineDesc = senderName + '  ' + sendTime;
          }
          if (m.is_active && m.task_object) {
            var t = m.task_object;
            var arrowDirection = t.content ? 'down' : null;
            var isLink = Boolean(t.link || arrowDirection);
            assign_default()(d, { isLink: isLink, arrowDirection: arrowDirection, content: t.content });
          }
          return d;
        });

        _this.$emit('loaded', data);
      }).catch(this.onServerResponseError);
    },
    onTitleClick: function onTitleClick(m) {
      var _this2 = this;

      if (m.arrowDirection === 'down') {
        m.arrowDirection = 'up';
      } else if (m.arrowDirection === 'up') {
        m.arrowDirection = 'down';
      }
      if (!m.isRead) {
        this.read(m).then(function () {
          if (!m.task.content) {
            _this2.goLink(m);
          }
        });
      } else {
        if (!m.task.content) {
          this.goLink(m);
        }
      }
    },
    onContentClick: function onContentClick(m) {
      this.goLink(m);
    },
    goLink: function goLink(m) {
      var link = m.task.link;
      if (link) {
        this.$emit('golink', link);
        this.$router.push(link);
      }
    },
    read: function read(m) {
      return this.$http.post('/message/message/' + m.key + '/read/').then(function (_ref2) {
        var data = _ref2.data;

        m.isRead = true;
        m.inlineDesc = m.senderName + '  ' + m.sendTime;
      });
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578ce804","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/message/components/List.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',{staticClass:"message-list",attrs:{"title":_vm.$attrs.title,"gutter":_vm.$attrs.gutter}},[_vm._l((_vm.messages),function(m){return [_c('cell',_vm._b({attrs:{"border-intent":false},nativeOn:{"click":function($event){return _vm.onTitleClick(m)}}},'cell',m,false),[_c('template',{slot:"icon"},[(!m.isRead)?_c('badge'):_vm._e()],1)],2),_vm._v(" "),(m.arrowDirection === 'up')?[_c('cell-box',{staticClass:"content",attrs:{"border-intent":false,"is-link":Boolean(m.task.link)},nativeOn:{"click":function($event){return _vm.onContentClick(m)}}},[_vm._v(_vm._s(m.content)+"\n            ")])]:_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var message_components_List = (esExports);
// CONCATENATED MODULE: ./src/views/message/message/components/List.vue
function injectStyle (ssrContext) {
  __webpack_require__("ifXo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_List,
  message_components_List,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var message_message_components_List = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HD9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("B9AI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J+7x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Performance;
/* harmony export (immutable) */ __webpack_exports__["c"] = userOnlineTimeCounter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_axios__ = __webpack_require__("blVE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters__ = __webpack_require__("hwoK");




/**
 * Created by denishuang on 2020/2/8.
 */




var INTERVAL = 5;
function DailyLog() {
    var a = {
        m: {},
        saveTime: undefined,
        delayMethods: {},
        log: function log(app, model, id, metics, subMetics, v, interval) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var k, dk, dm, it;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                k = app + '.' + model + '.' + id + '.' + metics + '.' + subMetics;
                                dk = Object(__WEBPACK_IMPORTED_MODULE_7__filters__["f" /* parseTime */])(new Date(), '{y}-{m}-{d}');
                                dm = _this.m[dk] || {};
                                it = interval || INTERVAL;

                                dm[k] = v;
                                _this.m[dk] = dm;
                                _this.delayMethods['save' + it + 's']();

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        save: function save() {
            return __WEBPACK_IMPORTED_MODULE_5__configs_axios__["a" /* $http */].post('/dailylog/dailylog/write/', this.m);
        },
        init: function init() {
            var _this2 = this;

            for (var i = 1; i <= 3; i++) {
                var p = Math.pow(2, i - 1) * INTERVAL;
                this.delayMethods['save' + p + 's'] = Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["throttle"])(function () {
                    return _this2.save();
                }, p * 1000);
            }
            return this;
        }
    };
    return a.init();
}

/* harmony default export */ __webpack_exports__["b"] = (DailyLog());
//     created () {

//         // console.log(this.delayMethods)
//     }
// })

function Performance(app, model, ownerId, target, interval) {
    var qd = { app: app, model: model, owner_id: ownerId };
    return {
        data: {
            parts: [],
            dates: [],
            target: target,
            score: null,
            times: 0
        },
        post: function post() {
            var d = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, qd, { detail: this.data });
            return __WEBPACK_IMPORTED_MODULE_5__configs_axios__["a" /* $http */].post('/dailylog/performance/write/', d);
        },

        save: Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["throttle"])(function () {
            this.post();
        }, interval || 10000),
        stack: function stack(s, v) {
            if (s[s.length - 1] !== v) {
                s.push(v);
            }
        },
        read: function read() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_5__configs_axios__["a" /* $http */].get('/dailylog/performance/read/?' + __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(qd)).then(function (_ref) {
                var data = _ref.data;

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.data, data.detail, { target: target });
                return _this3.data;
            });
        },
        addPart: function addPart(p) {
            this.stack(this.data.parts, p);
            var d = Object(__WEBPACK_IMPORTED_MODULE_7__filters__["f" /* parseTime */])(new Date(), '{y}-{m}-{d}');
            this.stack(this.data.dates, d);
            return this;
        },
        addScore: function addScore(score) {
            this.data.score = Math.max(this.data.score, score);
            return this;
        },
        addTimes: function addTimes(times) {
            this.data.times += times;
            return this;
        }
    };
}

function userOnlineTimeCounter(callBack) {
    var delta = 30;
    var m = { metics: { online_time: delta } };
    function action() {
        __WEBPACK_IMPORTED_MODULE_5__configs_axios__["a" /* $http */].post('/dailylog/user/count/', m).then(function (_ref2) {
            var data = _ref2.data;

            callBack(data.detail);
        });
    }
    action();
    setInterval(action, delta * 1000);
}

/***/ }),

/***/ "KhEi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MGUO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = setToken;
/* unused harmony export removeToken */
/* unused harmony export login */
/* harmony export (immutable) */ __webpack_exports__["b"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configs_axios__ = __webpack_require__("cjHl");




var TokenKey = 'access_token';

function getToken() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
    __WEBPACK_IMPORTED_MODULE_1__configs_axios__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token);
}

function removeToken() {
    delete __WEBPACK_IMPORTED_MODULE_1__configs_axios__["a" /* default */].defaults.headers.common['Authorization'];
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

function login(username, password) {
    __WEBPACK_IMPORTED_MODULE_1__configs_axios__["a" /* default */].post('/auth/user/login/', { username: username, password: password }).then(function (_ref) {
        var data = _ref.data;

        var token = data.token.access;
        setToken(token);
    });
}

function logout() {
    return __WEBPACK_IMPORTED_MODULE_1__configs_axios__["a" /* default */].get('/auth/user/logout/').then(function (_ref2) {
        var data = _ref2.data;

        removeToken();
        return data;
    });
}
/* unused harmony default export */ var _unused_webpack_default_export = ({
    getToken: getToken,
    setToken: setToken,
    removeToken: removeToken,
    login: login,
    logout: logout
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external "Vue"
var external__Vue_ = __webpack_require__("lRwf");
var external__Vue__default = /*#__PURE__*/__webpack_require__.n(external__Vue_);

// EXTERNAL MODULE: ./src/configs/axios.js
var axios = __webpack_require__("blVE");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: external "Vuex"
var external__Vuex_ = __webpack_require__("SJI6");
var external__Vuex__default = /*#__PURE__*/__webpack_require__.n(external__Vuex_);

// EXTERNAL MODULE: ./vue-django/src/utils/app_model.js
var app_model = __webpack_require__("rTN1");

// CONCATENATED MODULE: ./src/configs/apps.js
/**
 * Created by denishuang on 2017/8/9.
 */


var apps = {
    'exam': {
        verbose_name: '测验',
        models: {
            'paper': {
                verbose_name: '试卷'
            },
            'exam': {
                verbose_name: '考试',
                actions: [{ name: 'create', title: '创建', permission: 'post' }]
            },
            'answer': {
                verbose_name: '答卷'
            }
        }
    },
    'course': {
        verbose_name: '课程',
        models: {
            'course': {
                verbose_name: '课程'
            },
            'chapter': {
                verbose_name: '章节'
            }
        }
    },
    'survey': {
        verbose_name: '调查问卷',
        models: {
            'survey': {
                verbose_name: '问卷'
            },
            'answer': {
                verbose_name: '答卷'
            }
        }
    },
    'todo': {
        verbose_name: '待办',
        models: {
            'todo': {
                verbose_name: '待办'
            }
        }
    },
    'media': {
        verbose_name: '多媒体',
        models: {
            'video': {
                verbose_name: '视频'
            },
            'lecturer': {
                verbose_name: '讲师'
            },
            'image': {
                verbose_name: '图片'
            }
        }
    },
    'contenttypes': {
        verbose_name: '类别',
        models: {
            'contenttype': {
                verbose_name: '类别'
            }
        }
    },
    'comment': {
        verbose_name: '评论',
        models: {
            'comment': {
                verbose_name: '评论'
            }
        }
    },
    'points': {
        verbose_name: '积分',
        models: {
            'category': {
                verbose_name: '榜单'
            }
        }
    },
    'clockin': {
        verbose_name: '打卡',
        icon: 'check',
        models: {
            'project': {
                verbose_name: '计划',
                icon: 'home'
            },
            'group': {
                verbose_name: '小组',
                icon: 'home'
            },
            'session': {
                verbose_name: '周期',
                icon: 'clock-o'
            }
        }

    }
};

app_model["a" /* Register */].register(apps);

/* harmony default export */ var configs_apps = (apps);
// EXTERNAL MODULE: ./vue-django/src/utils/auth.js
var auth = __webpack_require__("MGUO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/lowdb/lib/main.js
var main = __webpack_require__("qSrU");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/lowdb/adapters/LocalStorage.js
var LocalStorage = __webpack_require__("DJAq");
var LocalStorage_default = /*#__PURE__*/__webpack_require__.n(LocalStorage);

// CONCATENATED MODULE: ./vue-django/src/utils/user_storage.js


/**
 * Created by denishuang on 2020/4/21.
 */




function Cache(key, db) {
    return {
        db: db,
        save: function save(v) {
            try {
                db.set(key, v).write();
            } catch (e) {
                alert(e.toString());
            }
        },
        read: function read(k) {
            return db.get(k || key).value();
        },
        destroy: function destroy() {
            console.log('destroy', key);
            try {
                db.unset(key).write();
            } catch (e) {
                alert(e.toString());
            }
        }
    };
}

function BCache(key, db) {
    function changeKey(k) {
        var ps = k.split('.');
        ps[2] = ps[2].replace(/^n/, '');
        return ps.join('.');
    }

    var cache = Cache(key, db);
    return extends_default()({}, cache, {
        read: function read(k) {
            return cache.read(k) || JSON.parse(localStorage.getItem(changeKey(k || key)));
        }
    });
}

/* harmony default export */ var user_storage = (BCache);

function UserStorage(key) {
    if (key === undefined) {
        key = 'userStore';
    }
    if (is_integer_default()(key)) {
        key = 'userStore' + key;
    }
    var adapter = new LocalStorage_default.a(key);
    var db = main_default()(adapter);
    return {
        db: db,
        newCache: function newCache(key) {
            return BCache(key, db);
        }
    };
}
// CONCATENATED MODULE: ./vue-django/src/store/modules/user.js

/**
 * Created by denishuang on 2020/5/15.
 */



/* harmony default export */ var modules_user = ({
    state: {
        storage: UserStorage()
    },
    mutations: {
        setUser: function setUser(state, payload) {
            assign_default()(state, payload, { storage: UserStorage(payload.id) });
        },
        clearUser: function clearUser(state) {
            state.user = {};
        }
    },
    actions: {
        getUserInfo: function getUserInfo(_ref) {
            var commit = _ref.commit,
                rootState = _ref.rootState;

            return external__Vue__default.a.http.get('/auth/user/current/').then(function (_ref2) {
                var data = _ref2.data;

                commit('setUser', data);
                rootState.bus.$emit('get-user-info', data);
                return data;
            });
        },
        logout: function logout(_ref3) {
            var commit = _ref3.commit,
                rootState = _ref3.rootState;

            return Object(auth["b" /* logout */])().then(function (data) {
                commit('clearUser');
                rootState.bus.$emit('user-logout');
                return data;
            });
        }
    }
});
// CONCATENATED MODULE: ./vue-django/src/store/modules/party.js



var party = {
    state: {
        name: null,
        logo: null
    },

    mutations: {
        setParty: function setParty(state, payload) {
            assign_default()(state, payload);
        }
    },
    actions: {
        getPartyInfo: function getPartyInfo(_ref) {
            var commit = _ref.commit,
                rootState = _ref.rootState;

            return external__Vue__default.a.http.get("/saas/party/current/").then(function (_ref2) {
                var data = _ref2.data;

                commit("setParty", data);
                rootState.bus.$emit('party-ready', data);
                return data;
            });
        }
    }
};

/* harmony default export */ var modules_party = (party);
// EXTERNAL MODULE: ./vue-django/src/utils/dailylog.js
var dailylog = __webpack_require__("J+7x");

// EXTERNAL MODULE: ./vue-django/src/assets/logo.png
var logo = __webpack_require__("uxgT");
var logo_default = /*#__PURE__*/__webpack_require__.n(logo);

// CONCATENATED MODULE: ./vue-django/src/store/index.js
/**
 * Created by denishuang on 2017/7/13.
 */









external__Vue__default.a.use(external__Vuex__default.a);
var store_state = {
    bus: new external__Vue__default.a(),
    dailyLog: dailylog["b" /* default */],
    apps: configs_apps,
    system_name: '',
    logo: logo_default.a
};

var store = new external__Vuex__default.a.Store({
    state: store_state,
    modules: {
        user: modules_user,
        party: modules_party
    },
    plugins: []
});
// Vue.prototype.$store = Vue.store =store
// store.dispatch('getUserInfo').catch((e) => {console.error(e)})
/* harmony default export */ var src_store = (store);
// CONCATENATED MODULE: ./src/store/index.js

/**
 * Created by denishuang on 2017/7/13.
 */
//



external__Vue__default.a.use(external__Vuex__default.a);
assign_default()(src_store.state, {
    cachedViews: ['course_course_list', 'exam_exam_list', 'media_video_list', 'about_me', 'about_vendor', 'student_exam_paper_list'],
    continueViews: ['exam_paper_detail', 'media_video_detail', 'course_course_detail', 'exam_fault_list', 'exam_paper_favorite', 'exam_exam_detail', 'exam_exam_list'],
    qcloud: {
        vod: {
            appId: '1251357229'
        }
    },
    currentCourse: null,
    examPaperTagsOrder: '\u7AE0\u8282\u4E60\u9898\n\u6BCF\u65E5\u4E00\u7EC3\n\u4E13\u9879\u7EC3\u4E60\n\u5386\u5E74\u771F\u9898\n\u6A21\u62DF\u771F\u9898\n\u7EFC\u5408\u7EC3\u4E60\n\u914D\u5957\u4E60\u9898'.split('\n').map(function (a, i) {
        return [a, i];
    }),
    examPaperReverseOrderTags: ['历年真题', '模拟真题']
});
external__Vue__default.a.set(src_store.state, 'todos', []);
external__Vue__default.a.set(src_store.state, 'fontSize', 16);
src_store.dispatch('getPartyInfo');
/* harmony default export */ var src_store_0 = (src_store);
// EXTERNAL MODULE: external "VueRouter"
var external__VueRouter_ = __webpack_require__("pRNm");
var external__VueRouter__default = /*#__PURE__*/__webpack_require__.n(external__VueRouter_);

// CONCATENATED MODULE: ./src/router/index.js


external__Vue__default.a.use(external__VueRouter__default.a);

var _import = __webpack_require__("A66B");

/* harmony default export */ var router = (new external__VueRouter__default.a({
    routes: [{
        path: '/',
        name: 'index',
        component: _import('index')
    }, {
        path: '/about/vendor',
        name: 'about_vendor',
        meta: {
            loginRequired: false
        },
        component: _import('about/vendor')
    }, {
        path: '/about/me',
        name: 'about_me',
        component: _import('about/me')
    }, {
        path: '/about/pclogin',
        name: 'about_pclogin',
        component: _import('about/pclogin')
    }, {
        path: '/auth/login',
        name: 'auth_login',
        component: _import('auth/login')
    }, {
        path: '/auth/change_password',
        name: 'auth_password',
        component: _import('auth/change_password')
    }, {
        path: '/exam/paper',
        name: 'student_exam_paper_list',
        component: _import('exam/paper/list')
    }, {
        path: '/exam/paper/fault',
        name: 'exam_paper_fault',
        component: _import('exam/paper/fault')
    }, {
        path: '/exam/paper/favorite',
        name: 'exam_paper_favorite',
        component: _import('exam/paper/favorite')
    }, {
        path: '/exam/exam/create',
        name: 'exam_exam_create',
        component: _import('exam/exam/create')
    }, {
        path: '/exam/exam/manage',
        name: 'exam_exam_manage',
        component: _import('exam/exam/manage')
    }, {
        path: '/exam/exam/:id/edit',
        name: 'exam_exam_edit',
        component: _import('exam/exam/edit')
    }, {
        path: '/exam/exam/:id/score',
        name: 'exam_exam_score',
        component: _import('exam/exam/score')
    }, {
        path: '/exam/exam/:id/review',
        name: 'exam_exam_review',
        component: _import('exam/exam/review')
    }, {
        path: '/exam/exam/:id/preview',
        name: 'exam_exam_preview',
        component: _import('exam/exam/preview')
    }, {
        path: '/exam/paper/:id',
        name: 'exam_paper_detail',
        component: _import('exam/paper/detail')
    }, {
        path: '/exam/exam/:id',
        name: 'exam_exam_detail',
        component: _import('exam/exam/detail')
    }, {
        path: '/exam/exam',
        name: 'exam_exam_list',
        component: _import('exam/exam/list')
    }, {
        path: '/exam/fault',
        name: 'exam_fault_list',
        component: _import('exam/fault/list')
    }, {
        path: '/media/video/:id',
        name: 'media_video_detail',
        component: _import('media/video/detail')
    }, {
        path: '/media/video',
        name: 'media_videolist',
        component: _import('media/video/list')
    }, {
        path: '/media/image/:id',
        name: 'media_image_detail',
        component: _import('media/image/detail')
    }, {
        path: '/comment/comment/new',
        name: 'comment_comment_edit',
        component: _import('comment/comment/edit')
    }, {
        path: '/comment/comment',
        name: 'comment_comment_list',
        component: _import('comment/comment/list')
    }, {
        path: '/comment/comment/:id',
        name: 'comment_comment_detail',
        component: _import('comment/comment/detail')
    }, {
        path: '/course/course',
        name: 'course_course_list',
        component: _import('course/course/list')
    }, {
        path: '/course/course/:id',
        name: 'course_course_detail',
        component: _import('course/course/detail')
    }, {
        path: '/course/report',
        name: 'course_course_report',
        component: _import('course/course/report')
    }, {
        path: '/survey/survey/:id',
        name: 'survey_survey_detail',
        component: _import('survey/survey/detail')
    }, {
        path: '/todo/todo',
        name: 'todo_todo_list',
        component: _import('todo/todo/list')
    }, {
        path: '/message/message',
        name: 'message_message_list',
        component: _import('message/message/list')
    }, {
        path: '/school/student/binding',
        component: _import('school/student/binding')
    }, {
        path: '/school/student/trial_application',
        component: _import('school/student/trial_application')
    }, {
        path: '/points/category/ranks',
        name: 'points_category_ranks',
        component: _import('points/category/ranks')
    }, {
        path: '/points/category/:id',
        name: 'points_category_detail',
        component: _import('points/category/detail')
    }, {
        path: '/clockin/group/mine',
        name: 'clockin_group_mine',
        component: _import('clockin/group/mine')
    }, {
        path: '/test',
        component: _import('test')
    }, {
        path: '/clear_cache',
        component: _import('clear_cache')
    }, {
        path: '/test_video',
        meta: { loginRequired: false },
        component: _import('test_video')
    }, { path: '/404', component: _import('errorPage/404'), hidden: true }, { path: '/401', component: _import('errorPage/401'), hidden: true }]
    // mode: 'history',
    // scrollBehavior (to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return { x: 0, y: 0}
    //     }
    // }
}));
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var node_modules_object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(node_modules_object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]}),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])]})],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: x_header_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_header = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("wYtD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_header,
  src_components_x_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df815522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("Z8d8")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/badge/index.vue + 3 modules
var badge = __webpack_require__("D8a4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: badge["a" /* default */]
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: badge["a" /* default */]
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fc8f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// EXTERNAL MODULE: ./vue-django/src/utils/array_normalize.js
var array_normalize = __webpack_require__("A6zj");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue-django/src/components/mobile/Tabbar.vue







/* harmony default export */ var Tabbar = ({
  props: {
    items: Array
  },
  data: function data() {
    return {
      tabItems: []
    };
  },
  created: function created() {
    this.normalizeItems();

    this.getBadges();
  },

  methods: {
    normalizeItems: function normalizeItems() {
      this.tabItems = Object(array_normalize["a" /* default */])(this.items, {}, function (a) {
        a.label = a.label || a.name;
        return a;
      });
    },
    getBadges: function getBadges() {
      var _this = this;

      this.tabItems.forEach(function (a, i) {
        if (a.getBadge) {
          _this.$http.get(a.getBadge).then(function (_ref) {
            var data = _ref.data;

            _this.tabItems[i] = extends_default()({}, a, { badge: data.count });
          });
        }
      });
    }
  },
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  },
  computed: {
    show: function show() {
      return this.tabItems.map(function (a) {
        return a.link;
      }).includes(this.$route.fullPath);
    }
  },
  watch: {
    items: function items(val) {
      this.normalizeItems();
    }
  }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue-django/src/components/mobile/Tabbar.vue







/* harmony default export */ var mobile_Tabbar = ({
  props: {
    items: Array
  },
  data: function data() {
    return {
      tabItems: []
    };
  },
  created: function created() {
    this.normalizeItems();

    this.getBadges();
  },

  methods: {
    normalizeItems: function normalizeItems() {
      this.tabItems = Object(array_normalize["a" /* default */])(this.items, {}, function (a) {
        a.label = a.label || a.name;
        return a;
      });
    },
    getBadges: function getBadges() {
      var _this = this;

      this.tabItems.forEach(function (a, i) {
        if (a.getBadge) {
          _this.$http.get(a.getBadge).then(function (_ref) {
            var data = _ref.data;

            _this.tabItems[i] = extends_default()({}, a, { badge: data.count });
          });
        }
      });
    }
  },
  components: {
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item
  },
  computed: {
    show: function show() {
      return this.tabItems.map(function (a) {
        return a.link;
      }).includes(this.$route.fullPath);
    }
  },
  watch: {
    items: function items(val) {
      this.normalizeItems();
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea56ffde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue-django/src/components/mobile/Tabbar.vue
var Tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabbar',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"position":"fixed"}},'tabbar',[_vm.$attrs],false),_vm.$listeners),_vm._l((_vm.tabItems),function(t){return _c('tabbar-item',{key:t.name,attrs:{"show-dot":t.showDot,"selected":t.link === _vm.$route.fullPath,"badge":t.badge,"link":t.link},scopedSlots:_vm._u([{key:"icon",fn:function(){return [(t.iconComponent)?_c(t.iconComponent,_vm._b({tag:"component"},'component',[t],false)):_vm._e(),_vm._v(" "),_c('i',{class:t.iconClass || ("iconfont icon-" + (t.icon))})]},proxy:true},{key:"label",fn:function(){return [(t.labelComponent)?_c(t.labelComponent,_vm._b({tag:"component"},'component',[t],false)):_c('span',{class:_vm.$attrs.labelClass},[_vm._v(_vm._s(t.label))])]},proxy:true}],null,true)})}),1)}
var Tabbar_staticRenderFns = []
var Tabbar_esExports = { render: Tabbar_render, staticRenderFns: Tabbar_staticRenderFns }
/* harmony default export */ var components_mobile_Tabbar = (Tabbar_esExports);
// CONCATENATED MODULE: ./vue-django/src/components/mobile/Tabbar.vue
var Tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tabbar___vue_template_functional__ = false
/* styles */
var Tabbar___vue_styles__ = null
/* scopeId */
var Tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tabbar___vue_module_identifier__ = null
var Tabbar_Component = Tabbar_normalizeComponent(
  mobile_Tabbar,
  components_mobile_Tabbar,
  Tabbar___vue_template_functional__,
  Tabbar___vue_styles__,
  Tabbar___vue_scopeId__,
  Tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_mobile_Tabbar = (Tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Tabbar.vue
//
//
//
//


/* harmony default export */ var layout_Tabbar = ({
    data: function data() {
        return {
            tabs: [{ name: '课程', iconClass: 'menu-cource', link: '/course/course' }, { name: '龙虎榜', iconClass: 'menu-ranking', link: '/points/category/ranks' }, { name: '我', iconClass: 'menu-user', link: '/about/me' }]
        };
    },

    components: { Tabbar: src_components_mobile_Tabbar },
    methods: {},
    computed: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/Tabbar.vue
//
//
//
//


/* harmony default export */ var components_layout_Tabbar = ({
    data: function data() {
        return {
            tabs: [{ name: '课程', iconClass: 'menu-cource', link: '/course/course' }, { name: '龙虎榜', iconClass: 'menu-ranking', link: '/points/category/ranks' }, { name: '我', iconClass: 'menu-user', link: '/about/me' }]
        };
    },

    components: { Tabbar: src_components_mobile_Tabbar },
    methods: {},
    computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755d0dd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Tabbar.vue
var layout_Tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabbar',{attrs:{"items":_vm.tabs,"icon-class":"menu-icon","labelClass":"menu__label"}})}
var layout_Tabbar_staticRenderFns = []
var layout_Tabbar_esExports = { render: layout_Tabbar_render, staticRenderFns: layout_Tabbar_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_layout_Tabbar = (layout_Tabbar_esExports);
// CONCATENATED MODULE: ./src/components/layout/Tabbar.vue
function Tabbar_injectStyle (ssrContext) {
  __webpack_require__("xIlm")
}
var layout_Tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var layout_Tabbar___vue_template_functional__ = false
/* styles */
var layout_Tabbar___vue_styles__ = Tabbar_injectStyle
/* scopeId */
var layout_Tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var layout_Tabbar___vue_module_identifier__ = null
var layout_Tabbar_Component = layout_Tabbar_normalizeComponent(
  components_layout_Tabbar,
  selectortype_template_index_0_src_components_layout_Tabbar,
  layout_Tabbar___vue_template_functional__,
  layout_Tabbar___vue_styles__,
  layout_Tabbar___vue_scopeId__,
  layout_Tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_layout_Tabbar = (layout_Tabbar_Component.exports);

// EXTERNAL MODULE: ./src/views/todo/todo/components/Dialog.vue + 3 modules
var Dialog = __webpack_require__("o/J3");

// EXTERNAL MODULE: ./src/views/message/message/components/Popup.vue + 3 modules
var Popup = __webpack_require__("nlYN");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue







/* harmony default export */ var App = ({
  name: 'app',
  components: { Tabbar: src_components_layout_Tabbar, TodoDialog: Dialog["default"], MessagePopup: Popup["default"], XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      cachedViews: [],
      title: null

    };
  },
  created: function created() {
    this.$store.state.bus.$on('user-logout', this.clearCachedViews);
    this.$store.state.bus.$on('get-user-info', this.setCachedViews);
    this.$store.state.bus.$on('party-ready', this.updateTitle);
  },

  methods: {
    updateTitle: function updateTitle() {
      var pname = this.$store.state.party.name;
      var t = document.title;
      if (pname && !t.startsWith(pname)) {
        document.title = pname + t;
        this.title = t === 'WECHAT_EMPTY_TITLE' ? pname : document.title;
      }
    },
    onTabChange: function onTabChange(v) {},
    setCachedViews: function setCachedViews() {
      this.cachedViews = this.$store.state.cachedViews;
    },
    clearCachedViews: function clearCachedViews() {
      this.cachedViews = [];
    }
  },
  computed: {
    showHeader: function showHeader() {
      return window.navigator.userAgent.includes('WindowsWechat');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue







/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app',
  components: { Tabbar: src_components_layout_Tabbar, TodoDialog: Dialog["default"], MessagePopup: Popup["default"], XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      cachedViews: [],
      title: null

    };
  },
  created: function created() {
    this.$store.state.bus.$on('user-logout', this.clearCachedViews);
    this.$store.state.bus.$on('get-user-info', this.setCachedViews);
    this.$store.state.bus.$on('party-ready', this.updateTitle);
  },

  methods: {
    updateTitle: function updateTitle() {
      var pname = this.$store.state.party.name;
      var t = document.title;
      if (pname && !t.startsWith(pname)) {
        document.title = pname + t;
        this.title = t === 'WECHAT_EMPTY_TITLE' ? pname : document.title;
      }
    },
    onTabChange: function onTabChange(v) {},
    setCachedViews: function setCachedViews() {
      this.cachedViews = this.$store.state.cachedViews;
    },
    clearCachedViews: function clearCachedViews() {
      this.cachedViews = [];
    }
  },
  computed: {
    showHeader: function showHeader() {
      return window.navigator.userAgent.includes('WindowsWechat');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5398bf62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"3rem"},attrs:{"id":"app"}},[(_vm.showHeader)?_c('x-header',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view')],1),_vm._v(" "),_c('tabbar'),_vm._v(" "),_c('todo-dialog'),_vm._v(" "),_c('message-popup')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Pk3r")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-infinite-scroll/vue-infinite-scroll.js
var vue_infinite_scroll = __webpack_require__("bqTm");
var vue_infinite_scroll_default = /*#__PURE__*/__webpack_require__.n(vue_infinite_scroll);

// EXTERNAL MODULE: ./vue-django/src/components/generic/ContentType.js
var ContentType = __webpack_require__("ysL2");

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__("Y81h");
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.css
var nprogress_nprogress = __webpack_require__("UVIz");
var nprogress_nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress_nprogress);

// CONCATENATED MODULE: ./src/router/permission.js



 // progress bar
 // progress bar style
 // getToken from cookie

nprogress_default.a.configure({ showSpinner: false }); // NProgress Configuration
var loginUrl = '/auth/login';
var continueViews = src_store_0.state.continueViews || [];

router.beforeEach(function (to, from, next) {
    nprogress_default.a.start(); // start progress bar
    var loginRequired = to.path === loginUrl ? false : to.matched.some(function (record) {
        return record.meta.loginRequired !== false;
    });
    if (!loginRequired) {
        next();
    } else {
        var token = Object(auth["a" /* getToken */])();
        if (token && !src_store_0.state.token) {
            src_store_0.state.token = token;
            Object(auth["c" /* setToken */])(token);
        }
        var user = src_store_0.state.user;
        var logined = user && user.id;
        if (!logined) {
            src_store_0.dispatch('getUserInfo').then(function (_ref) {
                var data = _ref.data;

                user = src_store_0.state.user;
                var roles = user.groups;
                // router.addRoutes(asyncRouterMap) //todo: make dynamics routers
                next(extends_default()({}, to, { replace: true })); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            }).catch(function (error) {
                Vue.$message({ message: '身份认证失败, 请重新登录', type: 'error' });
                next({ path: loginUrl, query: { redirect: to.fullPath } });
            });
        } else {
            // 权限判断
            var allowRoles = to.meta.roles;
            var isAllowed = true;

            if (isAllowed) {
                next();
            } else {
                next({ path: '/notallow' });
            }
        }
    }
});

var CU = 'continueurl';

function continueLastUrl(to, from) {
    try {
        if (continueViews.includes(to.name)) {
            localStorage.setItem(CU, to.fullPath);
        } else if (continueViews.includes(from.name)) {
            var ua = window.navigator.userAgent;
            if (/MicroMessenger/i.test(ua) && /iphone/i.test(ua)) {
                // 苹果微信会在关闭窗口时再一次访问 index, 这里要忽略, 不能删除历史
                if (to.name !== 'index') {
                    localStorage.removeItem(CU);
                }
            } else {
                localStorage.removeItem(CU);
            }
        }
    } catch (e) {
        Vue.$message({ message: e.toString() });
        console.log(e);
    }
}
router.afterEach(function (to, from) {
    nprogress_default.a.done();
    if (to.name !== null && from.name !== null) {
        continueLastUrl(to, from);
    }
});

router.onError(function (err) {
    nprogress_default.a.done();
    console.error(err);
    Vue.$message({ message: '\u53D1\u751F\u5F02\u5E38:' + err, type: 'error' });
});
// EXTERNAL MODULE: ./src/styles.css
var styles = __webpack_require__("qOWO");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles);

// CONCATENATED MODULE: ./src/main.js















external__Vue__default.a.directive('transfer-dom', transfer_dom["a" /* default */]);
external__Vue__default.a.config.productionTip = false;

external__Vue__default.a.use(loading["a" /* default */]);
external__Vue__default.a.use(toast["a" /* default */]);
external__Vue__default.a.use(plugins_confirm["a" /* default */]);
external__Vue__default.a.use(axios["b" /* default */]);
external__Vue__default.a.$message = external__Vue__default.a.prototype.$message = function (option) {
  var t = option.type;
  this.$vux.toast.show({
    text: option.message, type: t === 'error' ? 'cancel' : t === 'info' ? 'text' : t, time: 3000
  });
};
external__Vue__default.a.use(vue_infinite_scroll_default.a);
/* eslint-disable no-new */


ContentType["a" /* default */].loadIdMap();



Object(dailylog["c" /* userOnlineTimeCounter */])(function (data) {
  src_store_0.state.bus.$emit('user_online_timer', data);
});

new external__Vue__default.a({
  el: '#app-box',
  router: router,
  store: src_store_0,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "Opzk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/components/CopyRight.vue": [
		"rYmE",
		0,
		107
	],
	"./about/me.vue": [
		"m25N",
		0,
		60
	],
	"./about/pclogin.vue": [
		"vbcl",
		106
	],
	"./about/vendor.vue": [
		"77GA",
		81
	],
	"./auth/change_password.vue": [
		"Ns3B",
		0,
		48
	],
	"./auth/login.vue": [
		"N/Di",
		0,
		6
	],
	"./clear_cache.vue": [
		"Xmlz",
		105
	],
	"./clockin/group/components/Group.vue": [
		"ZGjw",
		0,
		45
	],
	"./clockin/group/components/Rank.vue": [
		"XZod",
		104
	],
	"./clockin/group/components/Review.vue": [
		"olNR",
		0,
		51
	],
	"./clockin/group/components/Sessions.vue": [
		"Mqli",
		0,
		53
	],
	"./clockin/group/mine.vue": [
		"Q8FB",
		0,
		33
	],
	"./clockin/session/components/Date.vue": [
		"17Xp",
		103
	],
	"./clockin/session/components/Session.vue": [
		"TWYP",
		79
	],
	"./comment/comment/components/Entry.vue": [
		"dbqH",
		0
	],
	"./comment/comment/components/Form.vue": [
		"4zxL",
		0,
		102
	],
	"./comment/comment/components/Popup.vue": [
		"JOSl",
		0
	],
	"./comment/comment/detail.vue": [
		"eOq3",
		0,
		37
	],
	"./comment/comment/edit.vue": [
		"KHix",
		0,
		101
	],
	"./comment/comment/list.vue": [
		"a4Rl",
		0,
		100
	],
	"./comment/favorite/components/Entry.vue": [
		"wkA2",
		0
	],
	"./comment/favorite/components/Popup.vue": [
		"9hGx",
		0,
		99
	],
	"./comment/rating/components/Entry.vue": [
		"2HzH",
		0,
		27
	],
	"./comment/rating/components/Popup.vue": [
		"JH6Q",
		0,
		98
	],
	"./course/course/components/CheckList.vue": [
		"3p+W",
		0,
		52
	],
	"./course/course/components/Counter.vue": [
		"5PF/",
		68
	],
	"./course/course/components/Course.vue": [
		"Kmh6",
		0,
		16
	],
	"./course/course/components/CourseOutline.vue": [
		"4DBV",
		97
	],
	"./course/course/components/Header.vue": [
		"hmoP",
		0,
		23
	],
	"./course/course/components/HourMinute.vue": [
		"5NAs",
		58
	],
	"./course/course/components/List.vue": [
		"iN7T",
		0,
		24
	],
	"./course/course/components/ListItem.vue": [
		"+Dah",
		67
	],
	"./course/course/components/OutlineCheckList.vue": [
		"gMWW",
		0,
		40
	],
	"./course/course/components/Pass.vue": [
		"pj6W",
		0,
		25
	],
	"./course/course/components/Progress.vue": [
		"iC08",
		34
	],
	"./course/course/components/Review.vue": [
		"/3Sq",
		0,
		73
	],
	"./course/course/components/Select.vue": [
		"lOmf",
		0,
		84
	],
	"./course/course/detail.vue": [
		"YPr/",
		0,
		1
	],
	"./course/course/list.vue": [
		"mUam",
		0,
		4
	],
	"./course/course/report.vue": [
		"ckiM",
		28
	],
	"./errorPage/401.vue": [
		"eRLo",
		82
	],
	"./errorPage/404.vue": [
		"AejC",
		54
	],
	"./exam/exam/components/Cells.vue": [
		"Fyz3",
		0,
		18
	],
	"./exam/exam/components/CountDown.vue": [
		"NEy/",
		96
	],
	"./exam/exam/components/Exam.vue": [
		"2rUJ",
		0,
		95
	],
	"./exam/exam/components/List.vue": [
		"Qu2n",
		0,
		83
	],
	"./exam/exam/components/ListItem.vue": [
		"5BIJ",
		0,
		64
	],
	"./exam/exam/components/PerformanceList.vue": [
		"46Md",
		0,
		94
	],
	"./exam/exam/components/PictureUpload.vue": [
		"sYs2",
		0,
		78
	],
	"./exam/exam/components/QuestionGenner.vue": [
		"Kr15",
		0,
		55
	],
	"./exam/exam/components/SubListItem.vue": [
		"xr6d",
		0,
		72
	],
	"./exam/exam/components/TypeCountInput.vue": [
		"4UqL",
		0,
		93
	],
	"./exam/exam/components/charts/BarScoreGroup.vue": [
		"dkVi",
		0,
		69
	],
	"./exam/exam/components/charts/DistributeGroup.vue": [
		"wudc",
		0,
		56
	],
	"./exam/exam/components/charts/PieScoreGroup.vue": [
		"/wyc",
		11
	],
	"./exam/exam/components/charts/StatSummary.vue": [
		"ETdw",
		0,
		92
	],
	"./exam/exam/create.vue": [
		"M7iW",
		0,
		15
	],
	"./exam/exam/detail.vue": [
		"vjgP",
		0,
		41
	],
	"./exam/exam/edit.vue": [
		"OBf7",
		0,
		77
	],
	"./exam/exam/list.vue": [
		"YN2J",
		0,
		74
	],
	"./exam/exam/manage.vue": [
		"NUXD",
		0,
		12
	],
	"./exam/exam/preview.vue": [
		"T4aZ",
		0,
		75
	],
	"./exam/exam/review.vue": [
		"M774",
		0,
		42
	],
	"./exam/exam/score.vue": [
		"FgQ8",
		0,
		3
	],
	"./exam/fault/components/Exercise.vue": [
		"C1aB",
		0,
		91
	],
	"./exam/fault/list.vue": [
		"M1sL",
		0,
		38
	],
	"./exam/paper/components/Board.vue": [
		"Of8G",
		36
	],
	"./exam/paper/components/Cells.vue": [
		"7vWT",
		0,
		17
	],
	"./exam/paper/components/CellsOld.vue": [
		"QZVq",
		71
	],
	"./exam/paper/components/Exercise.vue": [
		"mrbK",
		0
	],
	"./exam/paper/components/FontSizeRanger.vue": [
		"KCJz",
		29
	],
	"./exam/paper/components/FontSizeSelect.vue": [
		"HzB3",
		0
	],
	"./exam/paper/components/Grid.vue": [
		"QOji",
		0,
		8
	],
	"./exam/paper/components/GridItem.vue": [
		"DFds",
		0,
		30
	],
	"./exam/paper/components/List.vue": [
		"Lb48",
		0,
		13
	],
	"./exam/paper/components/ListItem.vue": [
		"pnPB",
		0,
		65
	],
	"./exam/paper/components/Manual.vue": [
		"7u+a",
		0
	],
	"./exam/paper/components/Performance.vue": [
		"aB6q",
		0,
		26
	],
	"./exam/paper/components/QuestionSwiper.vue": [
		"sVlX",
		0
	],
	"./exam/paper/components/Quiz.vue": [
		"nC8i",
		0,
		10
	],
	"./exam/paper/components/SubListItem.vue": [
		"CPx8",
		0,
		70
	],
	"./exam/paper/detail.vue": [
		"d/QS",
		0,
		7
	],
	"./exam/paper/fault.vue": [
		"MbcJ",
		0,
		66
	],
	"./exam/paper/favorite.vue": [
		"DW6z",
		0,
		90
	],
	"./exam/paper/list.vue": [
		"EYB7",
		89
	],
	"./index.vue": [
		"8hXn",
		0,
		80
	],
	"./media/image/components/Uploader.vue": [
		"IHN+",
		0,
		88
	],
	"./media/image/detail.vue": [
		"hwru",
		0,
		9
	],
	"./media/lecturer/components/Lecturer.vue": [
		"hG55",
		0,
		50
	],
	"./media/video/components/Cells.vue": [
		"Slp7",
		0,
		61
	],
	"./media/video/components/Exercise.vue": [
		"+fc6",
		0,
		5
	],
	"./media/video/components/Lecturer.vue": [
		"hu+m",
		0,
		39
	],
	"./media/video/components/List.vue": [
		"vIKy",
		0,
		22
	],
	"./media/video/components/ListItem.vue": [
		"R/58",
		0,
		62
	],
	"./media/video/components/Stepper.vue": [
		"GWqO",
		57
	],
	"./media/video/components/TabList.vue": [
		"YbVW",
		0,
		44
	],
	"./media/video/detail.vue": [
		"TMlP",
		0,
		2
	],
	"./media/video/list.vue": [
		"rj3W",
		0,
		20
	],
	"./message/message/components/List.vue": [
		"EtwV"
	],
	"./message/message/components/Popup.vue": [
		"nlYN"
	],
	"./message/message/list.vue": [
		"P8QD",
		87
	],
	"./points/category/components/Rank.vue": [
		"/Ic6",
		0,
		43
	],
	"./points/category/components/Rank2.vue": [
		"tkVb",
		0,
		49
	],
	"./points/category/components/StageItem.vue": [
		"dU/l",
		0
	],
	"./points/category/detail.vue": [
		"UQV5",
		0,
		32
	],
	"./points/category/ranks.vue": [
		"bADM",
		0,
		21
	],
	"./school/student/binding.vue": [
		"DgHH",
		0,
		47
	],
	"./school/student/components/ApplyRegister.vue": [
		"H6E1",
		86
	],
	"./school/student/trial_application.vue": [
		"IYD8",
		0,
		46
	],
	"./survey/survey/components/Group.vue": [
		"J7hb",
		0,
		31
	],
	"./survey/survey/components/MultiCheckInput.vue": [
		"65Vh",
		0
	],
	"./survey/survey/components/Paper.vue": [
		"fHI8",
		0,
		19
	],
	"./survey/survey/components/Question.vue": [
		"tMi7",
		0,
		59
	],
	"./survey/survey/detail.vue": [
		"sFWY",
		0,
		14
	],
	"./test.vue": [
		"BERp",
		0,
		63
	],
	"./test_video.vue": [
		"JhY7",
		35
	],
	"./todo/todo/components/Dialog.vue": [
		"o/J3"
	],
	"./todo/todo/components/List.vue": [
		"U8kp",
		0,
		85
	],
	"./todo/todo/list.vue": [
		"Pjsm",
		0,
		76
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "Pk3r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SJI6":
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ "TDCR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VTU+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZtS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5bfd958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",function(){return [_vm._v(_vm._s(_vm.leftText))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",function(){return [_vm._v(_vm._s(_vm.rightText))]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_popup_header = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7XXH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YEof":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YtqX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z8d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "blVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_django_src_configs_axios__ = __webpack_require__("cjHl");
/**
 * Created by denishuang on 2017/7/28.
 */

/* harmony default export */ __webpack_exports__["b"] = ({
  install: function install(Vue) {
    Vue.prototype.$http = __WEBPACK_IMPORTED_MODULE_0_vue_django_src_configs_axios__["a" /* default */];
    Vue.http = __WEBPACK_IMPORTED_MODULE_0_vue_django_src_configs_axios__["a" /* default */];
  },

  $http: __WEBPACK_IMPORTED_MODULE_0_vue_django_src_configs_axios__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_0_vue_django_src_configs_axios__["a" /* default */].setBaseURL('/api/');
var $http = __WEBPACK_IMPORTED_MODULE_0_vue_django_src_configs_axios__["a" /* default */];

/***/ }),

/***/ "cjHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);

/**
 * Created by denishuang on 2017/7/28.
 */





var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();

// function genBaseUrl (tpl) {
//     let a = tpl
//     location.pathname.split('/').forEach((s, i) => {
//         a = a.replace('$' + i, s)
//     })
//     if (a.startsWith('//')) {
//         a = a.slice(1)
//     }
//     return a
// }

instance.defaults.xsrfCookieName = 'csrftoken';
instance.defaults.xsrfHeaderName = 'X-CSRFToken';
instance.defaults.headers['X-REQUESTED-WITH'] = 'XMLHttpRequest';

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject({ code: error.response.status, msg: error.response.data });
    } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject({ code: '-1', msg: error.message });
    }
});

__WEBPACK_IMPORTED_MODULE_3_vue___default.a.prototype.$http = __WEBPACK_IMPORTED_MODULE_3_vue___default.a.http = instance;

instance.setBaseURL = function (url) {
    // instance.defaults.baseURL = genBaseUrl(url)
    var p = location.pathname.split(/\/(mobile|dashboard)\//g)[0];
    if (['/', ''].includes(p)) {
        instance.defaults.baseURL = url;
    } else {
        instance.defaults.baseURL = '' + p + url;
    }

    if (!__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get(instance.defaults.xsrfCookieName)) {
        instance.get('/csrf_token/');
    }
};
instance.setAuthToken = function (token) {
    instance.defaults.headers['Authorization'] = 'Token ' + token;
};
/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ "dh/b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hBGW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hwoK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateTime;
/* unused harmony export date2now */
/* unused harmony export date */
/* unused harmony export timeAgo */
/* harmony export (immutable) */ __webpack_exports__["f"] = parseTime;
/* unused harmony export localTimeStr */
/* harmony export (immutable) */ __webpack_exports__["d"] = formatTime;
/* harmony export (immutable) */ __webpack_exports__["e"] = nFormatter;
/* unused harmony export html2Text */
/* unused harmony export toThousandslsFilter */
/* unused harmony export percent */
/* harmony export (immutable) */ __webpack_exports__["c"] = duration;
/* unused harmony export json */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__("wuJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_locale_zh_cn__ = __webpack_require__("9G5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_locale_zh_cn__);


/**
 * Created by denishuang on 2017/11/16.
 */



function dateTime(t) {
    if (typeof t === 'string' && !t.includes('+')) {
        t = t.concat('+08:00');
    }
    return new Date(t);
}

function date2now(d) {
    return d;
}

function date(d) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["distance_in_words_to_now"])(d, { locale: __WEBPACK_IMPORTED_MODULE_3_date_fns_locale_zh_cn___default.a });
}

function pluralize(time, label) {
    if (time === 1) {
        return time + label;
    }
    return time + label + 's';
}

function timeAgo(time) {
    var between = Date.now() / 1000 - Number(time);
    if (between < 3600) {
        return pluralize(~~(between / 60), ' minute');
    } else if (between < 86400) {
        return pluralize(~~(between / 3600), ' hour');
    } else {
        return pluralize(~~(between / 86400), ' day');
    }
}

function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }

    if ((time + '').length === 10) {
        time = +time * 1000;
    }

    var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    var date = void 0;
    if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(time)) === 'object') {
        date = time;
    } else {
        date = new Date(parseInt(time));
    }
    var formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
        var value = formatObj[key];
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
        if (result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return time_str;
}

function localTimeStr(t) {
    return dateTime(t).toLocaleString();
}
function formatTime(time, option) {
    var d = dateTime(time);
    var now = new Date();

    var diff = (now - d) / 1000;
    if (diff >= 0) {
        if (diff < 60) {
            return '刚刚';
        } else if (diff < 3600) {
            // less 1 hour
            return Math.floor(diff / 60) + '分钟前';
        } else if (diff < 3600 * 24) {
            return Math.floor(diff / 3600) + '小时前';
        } else if (diff < 3600 * 24 * 2) {
            return '1天前';
        }
    }
    if (option) {
        return parseTime(time, option);
    } else {
        if (d.getYear() != now.getYear()) {
            return parseTime(d, '{y}-{m}-{d} {h}:{i}');
        }
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
    }
}

/* 数字 格式化 */
function nFormatter(num, digits, inChinese) {
    var si = inChinese ? [{ value: 1E12, symbol: '兆' }, { value: 1E8, symbol: '亿' }, { value: 1E4, symbol: '万' }] : [{ value: 1E18, symbol: 'E' }, { value: 1E15, symbol: 'P' }, { value: 1E12, symbol: 'T' }, { value: 1E9, symbol: 'G' }, { value: 1E6, symbol: 'M' }, { value: 1E3, symbol: 'k' }];
    for (var i = 0; i < si.length; i++) {
        if (num >= si[i].value) {
            return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
        }
    }
    return num.toString();
}

function html2Text(val) {
    var div = document.createElement('div');
    div.innerHTML = val;
    return div.textContent || div.innerText;
}

function toThousandslsFilter(num) {
    return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
        return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
    });
}

function percent(value, fixed) {
    var a = value && (value * 100).toFixed(fixed === undefined ? 2 : fixed);
    return a + '%';
}

function duration(a) {
    var m = Math.floor(a / 60);
    var s = Math.floor(a % 60);
    return m + '\'' + s + '\'\'';
}

function json(value, items) {
    console.log(value);
    if (items) {
        return items.map(function (a) {
            return (a.label || a.name) + ': ' + value[a.name];
        }).join('\n');
    } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(value).map(function (k) {
            return k + ': ' + value[k];
        }).join('\n');
    }
}

/* harmony default export */ __webpack_exports__["b"] = ({
    dateTime: dateTime,
    date2now: date2now,
    date: date,
    parseTime: parseTime,
    timeAgo: timeAgo,
    formatTime: formatTime,
    nFormatter: nFormatter,
    html2Text: html2Text,
    toThousandslsFilter: toThousandslsFilter,
    percent: percent,
    duration: duration,
    json: json
});

/***/ }),

/***/ "ifXo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3k2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lRwf":
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "lZ1g":
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "lZ1g";

/***/ }),

/***/ "mVB0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns__ = __webpack_require__("wuJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns__);

/**
 * Created by denishuang on 2017/7/27.
 */


function joinErrors(errors) {
    var es = {};
    for (var n in errors) {
        es[n] = errors[n].join("");
    }
    return es;
}

function formatDates(data) {
    var rs = {};
    for (var n in data) {
        var d = data[n];
        if (d instanceof Date) {
            rs[n] = Object(__WEBPACK_IMPORTED_MODULE_2_date_fns__["format"])(d, 'YYYY-MM-DD');
        } else {
            rs[n] = d;
        }
    }
    return rs;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            loading: false,
            loadingText: '数据加载中...',
            server_response_error: undefined
        };
    },

    // computed: {
    //   isTagsView() {
    //     // wayky add : 判断是否tagsView作tab导航
    //     return !!this.$store.state.tagsView
    //   }
    // },
    methods: {
        joinErrors: joinErrors,
        submitData: function submitData(url, data, successMsg, isCreate) {
            var _this = this;

            this.loading = true;
            this.errors = {};
            var action = isCreate ? this.$http.post : this.$http.put;
            var dt = this.restStyle ? data : __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(formatDates(data));
            var promise = action(url, dt).then(function (_ref) {
                var data = _ref.data;

                _this.loading = false;
                if (!_this.restStyle && data.code != 0) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject({ code: 400, msg: data.data.errors });
                }
                _this.$message({ message: successMsg || '提交成功', type: 'success' });
                return data;
            }).catch(this.onServerResponseError);
            return promise;
        },
        alertError: function alertError(error) {
            this.$message({
                message: error.code + '\u9519\u8BEF:' + error.msg, type: 'error'
            });
        },

        onServerResponseError: function onServerResponseError(error) {
            this.loading = false;
            if (error == 'cancel') {
                // confirm dialog cancel ?
                return;
            }
            if ([404, 403, 405, 406, 429, 537].includes(error.code) && error.msg.detail) {
                error.msg = error.msg.detail;
            }
            console.error(error);
            if (error.code === 400) {
                // this.errors = this.formErrors = joinErrors(error.msg)
            } else if (error.code === 401) {
                this.$store.state.bus.$emit('user-logout');
            } else if (error.code === 502) {
                this.alertError('网关错误');
            } else if (error instanceof Error) {
                this.alertError({ code: error.name, msg: error.message });
            } else {
                this.alertError(error);
            }
            return error;
            // this.server_response_error = error
        }
        //
        // resolveRoutePath(path) {
        //     return path
        //   // wayky add : 根据isTagsView自动给路由路径处理结尾的 / , tagView 组件的去掉结尾的 /
        //   if (this.isTagsView) {
        //     return path
        //   } else {
        //     if (path.indexOf('?') !== -1) {
        //       const p = path.split('?')
        //       return `${p[0]}/?${p[1]}`
        //     } else {
        //       return `${path}/`
        //     }
        //   }
        // },
        //
        // resolveCurrentTagLabel(path, title) {
        //   // wayky add : 根据isTagsView设置当前的Tag标签
        //   if (this.isTagsView) {
        //     this.$store.dispatch('setCurrentTagLabel', { path, title})
        //     // 同时修改
        //     this.$store.dispatch('updateLabelInVisitedViews', { path, title})
        //   }
        // }
    }
});

/***/ }),

/***/ "nlYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/index.vue + 3 modules
var popup = __webpack_require__("HD9R");

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup-header/index.vue + 3 modules
var popup_header = __webpack_require__("WZtS");

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-button/index.vue + 3 modules
var x_button = __webpack_require__("2sLL");

// EXTERNAL MODULE: ./src/views/message/message/components/List.vue + 3 modules
var List = __webpack_require__("EtwV");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/message/components/Popup.vue






/* harmony default export */ var Popup = ({
  data: function data() {
    return {
      messages: [],
      show: false
    };
  },

  components: { Popup: popup["a" /* default */], PopupHeader: popup_header["a" /* default */], XButton: x_button["a" /* default */], List: List["default"] },
  created: function created() {
    this.$store.state.bus.$on('get-user-info', this.load);
    setInterval(this.load, 600 * 1000);
  },

  methods: {
    load: function load() {
      this.$refs.list.load();
    },
    onLoaded: function onLoaded(data) {
      this.messages = data.results;
      this.show = this.messages.length > 0 && this.$route.name !== 'message_message_list';
    },
    onDone: function onDone() {
      var _this = this;

      var ids = this.messages.map(function (m) {
        return m.id;
      });
      this.$http.post('/message/message/batch_read/', { batch_action_ids: ids }).then(function (_ref) {
        var data = _ref.data;

        _this.load();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/message/message/components/Popup.vue






/* harmony default export */ var components_Popup = ({
  data: function data() {
    return {
      messages: [],
      show: false
    };
  },

  components: { Popup: popup["a" /* default */], PopupHeader: popup_header["a" /* default */], XButton: x_button["a" /* default */], List: List["default"] },
  created: function created() {
    this.$store.state.bus.$on('get-user-info', this.load);
    setInterval(this.load, 600 * 1000);
  },

  methods: {
    load: function load() {
      this.$refs.list.load();
    },
    onLoaded: function onLoaded(data) {
      this.messages = data.results;
      this.show = this.messages.length > 0 && this.$route.name !== 'message_message_list';
    },
    onDone: function onDone() {
      var _this = this;

      var ids = this.messages.map(function (m) {
        return m.id;
      });
      this.$http.post('/message/message/batch_read/', { batch_action_ids: ids }).then(function (_ref) {
        var data = _ref.data;

        _this.load();
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a763431","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/message/components/Popup.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],staticClass:"message-popup"},[_c('popup',{attrs:{"popup-style":{'z-index': 2000}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('popup-header',{attrs:{"left-text":("您当前有" + (_vm.messages.length) + "条未读消息.")}}),_vm._v(" "),_c('list',{ref:"list",staticStyle:{"max-height":"20rem","overflow-y":"scroll"},attrs:{"autoLoad":false,"gutter":0,"queries":{is_read:false}},on:{"loaded":_vm.onLoaded,"golink":function($event){_vm.show=false}}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.onDone.apply(null, arguments)}}},[_vm._v("好的, 我知道了")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var message_components_Popup = (esExports);
// CONCATENATED MODULE: ./src/views/message/message/components/Popup.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_Popup,
  message_components_Popup,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var message_message_components_Popup = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "o/J3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/index.vue + 3 modules
var cell = __webpack_require__("1DHf");

// EXTERNAL MODULE: external "Vuex"
var external__Vuex_ = __webpack_require__("SJI6");
var external__Vuex__default = /*#__PURE__*/__webpack_require__.n(external__Vuex_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/todo/todo/components/Dialog.vue







/* harmony default export */ var Dialog = ({
  data: function data() {
    return {};
  },

  components: { XDialog: x_dialog["a" /* default */], Group: group["a" /* default */], Cell: cell["a" /* default */] },
  created: function created() {
    this.load();
    this.$store.state.bus.$on('todo-done', this.load);
  },

  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/todo/todo/current/').then(function (_ref) {
        var data = _ref.data;

        _this.$store.state.todos = data.results;
      }).catch(function (e) {
        console.error(e);
      });
    }
  },
  computed: extends_default()({
    show: function show() {
      if (this.todos.length < 1) {
        return false;
      }
      var urls = this.todos.map(function (a) {
        return a.url;
      });

      if (urls.includes(this.$route.path) || urls.includes(this.$route.path + '/')) {
        return false;
      }
      return true;
    }
  }, Object(external__Vuex_["mapState"])(['todos']))
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/todo/todo/components/Dialog.vue







/* harmony default export */ var components_Dialog = ({
  data: function data() {
    return {};
  },

  components: { XDialog: x_dialog["a" /* default */], Group: group["a" /* default */], Cell: cell["a" /* default */] },
  created: function created() {
    this.load();
    this.$store.state.bus.$on('todo-done', this.load);
  },

  methods: {
    load: function load() {
      var _this = this;

      this.$http.get('/todo/todo/current/').then(function (_ref) {
        var data = _ref.data;

        _this.$store.state.todos = data.results;
      }).catch(function (e) {
        console.error(e);
      });
    }
  },
  computed: extends_default()({
    show: function show() {
      if (this.todos.length < 1) {
        return false;
      }
      var urls = this.todos.map(function (a) {
        return a.url;
      });

      if (urls.includes(this.$route.path) || urls.includes(this.$route.path + '/')) {
        return false;
      }
      return true;
    }
  }, Object(external__Vuex_["mapState"])(['todos']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f9f59e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/todo/todo/components/Dialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('group',{staticStyle:{"text-align":"left"},attrs:{"title":"待办事项"}},_vm._l((_vm.todos),function(t){return _c('cell',{key:t.id,attrs:{"link":t.url,"title":t.title || t.name}})}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var todo_components_Dialog = (esExports);
// CONCATENATED MODULE: ./src/views/todo/todo/components/Dialog.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_Dialog,
  todo_components_Dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var todo_todo_components_Dialog = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pRNm":
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ }),

/***/ "qOWO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("xi8R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("YtqX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rTN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export joinErrors */
/* unused harmony export AppModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Register; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configs_axios__ = __webpack_require__("cjHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);



/**
 * Created by denishuang on 2017/11/29.
 */


function joinErrors(errors) {
    var es = {};
    for (var n in errors) {
        es[n] = errors[n].join('');
    }
    return es;
}

function AppModel(config) {
    return {
        name: config.name,
        fullName: config.app + '.' + config.name,
        verboseName: config.verbose_name,
        title_field: config.title_field || 'name',
        listUrl: config.app + '/' + config.name + '/',
        config: config,
        errors: {},
        loadOptions: function loadOptions() {
            if (config.rest_options) {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(config.rest_options);
            }
            return __WEBPACK_IMPORTED_MODULE_3__configs_axios__["a" /* default */].options(this.listUrl).then(function (_ref) {
                var data = _ref.data;

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(config, { rest_options: data });
                return data;
            });
        },
        loadObject: function loadObject(id) {
            return __WEBPACK_IMPORTED_MODULE_3__configs_axios__["a" /* default */].get('' + this.listUrl + id + '/').then(function (_ref2) {
                var data = _ref2.data;

                return data;
            });
        },
        query: function query(d, url) {
            if (!url) {
                url = this.listUrl;
            }
            return __WEBPACK_IMPORTED_MODULE_3__configs_axios__["a" /* default */].get(url + '?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(d, { arrayFormat: 'comma' })).then(function (_ref3) {
                var data = _ref3.data;

                return data;
            });
        },
        updateOrCreate: function updateOrCreate(s, d) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3__configs_axios__["a" /* default */].get(this.listUrl + '?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(s)).then(function (_ref4) {
                var data = _ref4.data;

                if (data.count === 1) {
                    var id = data.results[0].id;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(id);
                } else if (data.count > 1) {
                    throw Error('不是唯一');
                } else {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(undefined);
                }
            }).then(function (id) {
                if (id) {
                    return __WEBPACK_IMPORTED_MODULE_3__configs_axios__["a" /* default */].put('' + _this.listUrl + id + '/', d);
                } else {
                    return __WEBPACK_IMPORTED_MODULE_3__configs_axios__["a" /* default */].post(_this.listUrl, d);
                }
            });
        },
        genEmptyDataFromRestOptions: function genEmptyDataFromRestOptions(m) {
            var r = {};
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(m).forEach(function (k) {
                var f = m[k];
                r[k] = f.type === 'boolean' ? true : f.multiple ? [] : f.type === 'string' ? '' : null;
            });
            return r;
        }
    };
}

var Register = {
    configs: {},
    register: function register(apps) {
        var cs = this.configs;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(apps).forEach(function (a) {
            var app = apps[a];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(app.models).forEach(function (m) {
                var model = app.models[m];
                var config = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ app: a, name: m, fullName: a + '.' + m }, model);
                // let amodel = AppModel(config)
                cs[config.app + '.' + config.name] = config;
            });
        });
    },
    get: function get(fullName) {
        return AppModel(this.getConfig(fullName));
    },
    getConfig: function getConfig(fullName) {
        var config = this.configs[fullName];
        if (!config) {
            throw Error('model ' + fullName + ' not found!');
        } else {
            return config;
        }
    }
};

/* unused harmony default export */ var _unused_webpack_default_export = (AppModel);

/***/ }),

/***/ "uxgT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.82b9c7a.png";

/***/ }),

/***/ "wYtD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xIlm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xi8R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ysL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configs_axios__ = __webpack_require__("cjHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_Model__ = __webpack_require__("6OHj");
/**
 * Created by denishuang on 2019/10/15.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
    idMap: undefined,
    nameMap: undefined,
    model: Object(__WEBPACK_IMPORTED_MODULE_1__model_Model__["a" /* default */])('contenttypes.contenttype'),
    loading: false,
    getAppModel: function getAppModel(id) {
        if (this.idMap === undefined) {
            return;
        }
        var d = this.idMap[id];
        return Object(__WEBPACK_IMPORTED_MODULE_1__model_Model__["a" /* default */])(d.app_label + '.' + d.model);
    },
    getId: function getId(name) {
        return this.nameMap[name];
    },
    loadIdMap: function loadIdMap() {
        var _this = this;

        if (this.idMap === undefined && this.loading === false) {
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__configs_axios__["a" /* default */].get(this.model.getListUrl() + 'all/?page_size=1000').then(function (_ref) {
                var data = _ref.data;

                return data.results;
            }).then(function (ls) {
                var idm = {};
                var nm = {};
                ls.forEach(function (a) {
                    idm[a.id] = a;
                    nm[a.app_label + '.' + a.model] = a.id;
                });
                _this.idMap = idm;
                _this.nameMap = nm;
                _this.loading = false;
            }).catch(function (e) {
                _this.loading = false;
            });
        }
    }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5829d23bf84deb4193e4.js